function stripHtml(value = '') {
  return String(value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function getHubContentKind(postType) {
  const type = String(postType || '').toLowerCase();
  if (type === 'events' || type.includes('event')) {
    return { label: 'Event', cta: 'View event', ctaShort: 'View' };
  }
  if (type.includes('podcast')) {
    return { label: 'Podcast', cta: 'Listen now', ctaShort: 'Listen' };
  }
  if (type === 'news' || type.includes('news')) {
    return { label: 'News', cta: 'Read story', ctaShort: 'Read' };
  }
  if (type.includes('blog')) {
    return { label: 'Blog', cta: 'Read article', ctaShort: 'Read' };
  }
  return { label: 'Article', cta: 'Read more', ctaShort: 'Read' };
}

export function parseHubListingTitle(rawTitle = '', postType) {
  const title = stripHtml(rawTitle);
  const fallback = getHubContentKind(postType).label;
  const seriesMatch = title.match(
    /^(Guest Speak)\s+Part\s+(\d+)\s*(?:\([^)]*\))?\s*[:\-–—]\s*(.+)$/i,
  );

  if (seriesMatch) {
    return {
      eyebrow: `${seriesMatch[1]} · Part ${seriesMatch[2]}`,
      headline: seriesMatch[3].trim(),
      fullTitle: title,
    };
  }

  const genericPart = title.match(/^(.+?)\s+Part\s+(\d+)\s*[:\-–—]\s*(.+)$/i);
  if (genericPart) {
    return {
      eyebrow: `${genericPart[1].trim()} · Part ${genericPart[2]}`,
      headline: genericPart[3].trim(),
      fullTitle: title,
    };
  }

  return {
    eyebrow: fallback,
    headline: title,
    fullTitle: title,
  };
}

export function excerptFromContent(content = '', max = 140) {
  const text = stripHtml(content);
  if (!text) return '';
  if (text.length <= max) return text;
  return `${text.slice(0, max).trimEnd()}…`;
}

export function eventLocationLine(item) {
  const addr = item?.addressData;
  if (!addr) return '';
  return [addr.city, addr.state, addr.country].filter(Boolean).join(', ');
}
